import { TaxDetailPage } from "@/features/tax/pages/TaxDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/tax/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["tax.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: TaxDetailPage,
});
